import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Button, Col, Form, FormGroup, Row } from "reactstrap";
import { Form as FinalForm, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import { isRequired, combineValidators } from "revalidate";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import TenantLogo from "../common/TenantLogo";
import TextInput from "../common/TextInput";

const validate = combineValidators({
  password: isRequired("password"),
});

const PodiumLogoutForm: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { currentTenant } = rootStore.tenantStore;
  const { podiumLogout } = rootStore.podiumStore;
  const { theme } = rootStore.commonStore;
  const { user } = rootStore.userStore;
  const [t] = useTranslation(["podium", "translation"], translationHookOptions);
  return (
    <>
      <div className="form-wrapper podium-logout-form mt-0">
        <div>
          <TenantLogo
            className="podium-logout-tenant-image"
            tenant={currentTenant!}
          />
          <h5 className="font-weight-bold">{currentTenant!.name}</h5>
        </div>
        <h5 className="my-4">{t("logout_modal_msg")}</h5>
        {user && (
          <FormGroup className="form-group input-group-lg">
            <input
              className="form-control mt-2"
              value={user?.email}
              autoComplete="off"
              readOnly
            ></input>
          </FormGroup>
        )}

        <FinalForm
          initialValues={{ password: "" }}
          onSubmit={(values: { password: string }) =>
            podiumLogout(values.password).catch((error) => ({
              [FORM_ERROR]: error,
            }))
          }
          validate={validate}
          render={({
            handleSubmit,
            submitting,
            submitError,
            invalid,
            pristine,
            dirtySinceLastSubmit,
          }) => (
            <Form onSubmit={handleSubmit} role="form">
              <FormGroup className="form-group input-group-lg">
                <Field
                  name="password"
                  component={TextInput}
                  className="form-control mt-2"
                  placeholder={t("password_placeholder", { ns: "translation" })}
                  type="password"
                  auautoComplete="current-password"
                />
              </FormGroup>
              {submitError && !dirtySinceLastSubmit && (
                <Alert color="danger">{t("invalid_credentials", { ns: "translation" })}</Alert>
              )}
              <Row>
                <Col>
                  <Button
                    disabled={(invalid && !dirtySinceLastSubmit) || pristine || submitting}
                    className={classNames(
                      "genericButton podium-logout-modal-btn mt-2",
                      `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                        theme!.buttonTextColor
                      }`
                    )}
                    color="dark"
                    type="submit"
                  >
                    {t("navbar_dropdown_logout", { ns: "translation" })}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        />
      </div>
    </>
  );
};

export default observer(PodiumLogoutForm);
